import { render, staticRenderFns } from "./GoalParents.vue?vue&type=template&id=c934b33e&"
import script from "./GoalParents.vue?vue&type=script&lang=js&"
export * from "./GoalParents.vue?vue&type=script&lang=js&"
import style0 from "./GoalParents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports